import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import SliderExample from '../examples/Slider';
const SliderExampleSource = require('!!raw-loader!../examples/Slider');
export default class SliderPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Slider"/>
                <h3>Slider</h3>
                <div className="docs-example">
                    <div className="mx-5 my-7">
                        <SliderExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{SliderExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>Slider Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
type Props = {|
  range: Array<RangeType>,
  value: number,
  disabled: boolean,
  pips: boolean,
  children: (value: number) => Node,
  className?: string,
  id?: string,
  name?: string,
  onChange?: (value: number) => void,
  onChangeComplete?: (value: number) => void,
|};

static defaultProps = {
  value: 0,
  disabled: false,
  range: [ { value: 0, step: 1 }, { value: 100 } ],
  children: (value: number) => <div className="StepRangeSlider__tooltip">{value}</div>,
  pips: true,
};
`}
                        </PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
